import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { withStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'

import * as UnitActionCreators from '../../actions/unit'
import * as DeviceActionCreators from '../../actions/device'
import * as TimeseriesActionCreators from '../../actions/timeseries'

import PageTitle from '../controls/PageTitle'
import DeviceListView from '../device/DeviceListView'

import OrganizationAdminContainer from './OrganizationAdminContainer'
import CommunityAdminContainer from './CommunityAdminContainer'
import UnitAdminContainer from './UnitAdminContainer'

class AdminPage extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    classes: PropTypes.object.isRequired,
    /* mapped state */
    devices: PropTypes.object.isRequired,
    devicesByUnit: PropTypes.object.isRequired,
    /* mapped dispatch */
    timeseriesActions: PropTypes.object.isRequired,
    deviceActions: PropTypes.object.isRequired,
    unitActions: PropTypes.object.isRequired,
  }

  static styles = (theme) => ({
    section: {
      marginBottom: theme.spacing(3),
    },
  })

  static mapStateToProps(state) {
    return {
      devices: state.devices,
      devicesByUnit: state.devicesByUnit,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      unitActions: bindActionCreators(UnitActionCreators, dispatch),
      deviceActions: bindActionCreators(DeviceActionCreators, dispatch),
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
    }
  }

  componentDidMount() {
    // List un-assigned devices
    this.props.unitActions.listUnitDevices(0)
  }

  render() {
    const {
      classes,
      devices, devicesByUnit, deviceActions,
      timeseriesActions,
    } = this.props

    const deviceIds = devicesByUnit[0] || []
    const unitDevices = []
    deviceIds.forEach((id) => {
      if (devices[id]) {
        unitDevices.push(devices[id])
      }
    })
    const timeseries = {}

    return (
      <>
        <PageTitle title="BlokSense Insights Admin" />

        <Typography variant="h6">Organizations</Typography>
        <div className={classes.section}>
          <OrganizationAdminContainer />
        </div>

        <Typography variant="h6">Communities</Typography>
        <div className={classes.section}>
          <CommunityAdminContainer />
        </div>

        <Typography variant="h6">Units</Typography>
        <div className={classes.section}>
          <UnitAdminContainer />
        </div>

        <DeviceListView
          devices={unitDevices}
          onUpdateDevice={deviceActions.updateDevice}
          onRemoveDevice={deviceActions.removeDevice}
          timeseries={timeseries}
          onAddUnitTimeseries={timeseriesActions.addUnitTimeseries}
          onSaveUnitTimeseries={timeseriesActions.saveUnitTimeseries}
        />
      </>
    )
  }
}

export default withStyles(AdminPage.styles)(connect(AdminPage.mapStateToProps, AdminPage.mapDispatchToProps)(AdminPage))
